import { render, staticRenderFns } from "./Teachspection.vue?vue&type=template&id=6cbea84f&scoped=true&"
import script from "./Teachspection.vue?vue&type=script&lang=js&"
export * from "./Teachspection.vue?vue&type=script&lang=js&"
import style0 from "./Teachspection.vue?vue&type=style&index=0&id=6cbea84f&scoped=true&lang=css&"
import style1 from "./Teachspection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbea84f",
  null
  
)

export default component.exports